import {Breadcrumbs, CircularProgress, Grid, Typography} from '@mui/material';
import { Home } from '@mui/icons-material';
import PageTitle from '../../../common/PageTitle';
import LinkNavegacao from '../../../common/Link';
import CardOption from '../../../common/CardOption';
import { NotificationIcon } from '../../../common/Icons';
import {useEffect, useState} from "react";
import {verifyUserAbilities} from "../../../config/functions";

function Alerts() {
    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesNecessarias = [
        { rota: "alertas", title: "Alertas Disparados", description: "Visualize os Alertas que foram disparados.", url: "lista_alertas" },
        { rota: "configAlarme", title: "Configuração dos Alarmes", description: "Gerencie os Alarmes das empresas.", url: "config_alertas" }
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            const resultados = {};

            for (const item of permissoesNecessarias) {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);


    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}
        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><Home fontSize='small' /></LinkNavegacao>
                    <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao>
                    <Typography variant='span'>Alertas</Typography>
                </Breadcrumbs>

                <PageTitle icon={<NotificationIcon fontSize='large' />} title='Alertas' />
            </Grid>

            {permissoesNecessarias.map((item) => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default Alerts;